

const ServiceUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case "PutServiceUpdateSuccess":
            return Object.assign({}, state, {
                ServiceUpdate: action.data,
            });
            break;
        case "PutServiceUpdateFailure":
            return Object.assign({}, state, {
                arraylist: action.data,
            });
            break;
        case "GetServiceSearchSuccess":
            return Object.assign({}, state, {
                SearchServiceUpdate: action.data,
            });
        case "GetMMPLSearchSuccess":
            return Object.assign({}, state, {
                serviceUpdateSearchResult: action.data,
            });
            break;
        case "GetMMPLSearchFailure":
            return Object.assign({}, state, {
                serviceUpdateSearchResult: action.data,
            });
            break;
            break;
        case "GetServiceSearchFailure":
            return Object.assign({}, state, {
                arraylist: action.data,
            });
            break;
        case "IsServiceUpdate":
            return Object.assign({}, state, {
                IsServiceUpdate: action.data,
            });
            break;
        default: {
            return state;
        }
    }
};
export default ServiceUpdateReducer;
